module.exports = __webpack_public_path__ + "img/mongolia.b532ded8.svg";